var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_1815",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_1815",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAEi0lEQVR4nO3cT0wcVRwH8O9vhgW2Be3JJmo1Ueih3vTgzURTGk09eJDa+C/xQGpS29QGWBBpf2JBFlpIwPTCrYnYyKUHJRZ77cnE2IvGFGsiRutJLeBStvN+HliTuvPedrez5Fnm90m4zHtv9pf3nZmdWXYfoJRSSimllFJKKaWUUkoppdRWRrUO6OeR3SbCSwA6QPIwgF0Atte9snvDKoAlCP1CJAuRMRfGTw1erWUHVQeQGxx6ghCMCtGLNZeZJkKXTCi5cR74pprudwyAmRvWpPGMiLwDIEhcYDoYEE1lab2HmW9V6lgxgGPMO5qixjmQ7K1vfSkhsoD1hgP5fN9fri7OI7qz87OwyWRmdfITINqHpmiOmRtcXZwBPL5ncQLAC5tSWLp0FExmzNVovQT18PCTgcHXcAYk1wU0RRLOR4Vw8fTpntW6lHqP6e4e3x5mozbA7AfJUQA7HV2NCfDUOA98W95gPTWCiPIgsU6+gD41fzd2pXXSb1eagysArjDzVEEyMxActHQNAoNRAM+XN8TOgH4e2W2M/GB9RcJs/oP3XgdIEta+RQnlTo7MOkIABUH7KPcv3r4tdpSXHrJsO7+epeIhnfxKSLJU7ALwu61Voig2t7bLTId1MGiKmVeSFbj1MfOKANOO5tjcxgMgecQ20gT4Illp6UESfm5voEfLN9nOgAdtY1tQvJasrPTIhms/OpoeKt9gC6DFNlIvP9WrMFexudXPdjzTADxzfkZRLndiWG8/N4GeAZ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5V/RyQHxqo+TtEaVbtc5OeAZ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5pAJ5V/f+ArYKZt61JZlwErwG4v8bhfwL4ZH052zM5ebxQj3pSF0DBZCYAHLrL4TsAHG5sLTQAeLse9aTqEsTMAYA367CrN0r7SixVAfwfpSoAZjYAziXdjxDOlfaVWKoCAID15ey7RPQxNt5Qa/UHgOnijezxetWTujfh0t3LkdKfd7YzYNnWkZmtv5xRccx8n6PpRvkGWwC/2UauIPNYkqLSZNU9V7+Wb4gHIPSzbWQY6TpB1QpccyUSm9tYAESyYB1MclQvQ3fW25tvBdnfX4goNrexACJjLjj2vbMgmRlA9CuKTkJojmYAecDWaptb62TmBk9dBNE+62sQzmep2KU/W/2v3t58K5qjGYK8YmsXkS/HPnw/tvyP9TbUhJQLDPbC+h6BgwXJPNt7Yng6kGC+Obx5Na1hMHPLWtTULpD9oOiI68gHYExIOVuD83KSOzkyCZFjdak05QQ4MzY00G1rcz4JX/uurVtE5jevrNT4altQ7HM1OgOYmzsQ0XrDqxDHXZGqxsVsUHy50sqJYaXRly9futnx3DPnb0nYCuBp3MVCryllBJj46fv2t86ePbxWqWPVE9rPI3uMAQPSmby+LWxj4dYe2/pwNjUf0X38UVtp5acOEO3CxtLFaX1AWwGwBJElIvp36WLXUjVKKaWUUkoppZRSSimllFJKpdA/pSRmvXckapYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.dbf3c88c8b87adaac58e3cef16b29676.svg";
export { ForwardRef as ReactComponent };